export function getStatus(status,vm){
  /*0-待审核 1-已结束 2-已拒绝 3-进行中 4-已过期 5-已冻结 6-已完成 7-已取消 8-转出审核中*/
  let text = '';
  switch (status) {
    case 0:
      text = vm.$t('withgold.withgoldOut1');
      break;
    case 1:
      text = vm.$t('withgold.statusEnd');
      break;
    case 2:
      text = vm.$t('withgold.withgoldOut3');
      break;
    case 3:
      text = vm.$t('withgold.statusDuring');
      break;
    case 4:
      text = vm.$t('withgold.statusExpired');
      break;
    case 5:
      text = vm.$t('withgold.statusFree');
      break;
    case 6:
      text = vm.$t('withgold.statusComple');
      break;
    case 7:
      text = vm.$t('withgold.statusCancle');
      break;
    case 8:
      text = vm.$t('withgold.statusReview');
      break;
    case 9:
      text = vm.$t('bonusList.Rejection_of_regularization');
      break;
    case 10:
      text = vm.$t('bonusList.Passed_the_regularization');
      break;
  }
  return text;
}
